import React from 'react'
import { useContext } from 'react';
import GlobalState from '../../contexts/GlobalState';

export default function BlueArrow() {
    const { generalDataGlobal } = useContext(GlobalState);
    const locale = localStorage.getItem('language');
    return (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{transform: `rotate(${locale === 'en' ? '' : '180deg'})`}}
    >
        <path
        d="M5 12L20 12M20 12L14.375 6M20 12L14.375 18"
        stroke={`${generalDataGlobal[0]?.general?.secondary_color}`}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
  </svg>
  )
}
